<template>
	<div class="page measure-yarn-count">
		<section id="navigation">
			<div class="container">
				<div class="content flex">
					<span @click="$router.go(-1);" class="go-back"><svg class="navigation-icon link-icon small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 20"><path d="M.8 10L10.36.44 13.2 3.3 6.5 10l6.72 6.7-2.85 2.85L.8 10z"/></svg></span>
					<span class="navigation-title">{{$t('measure-yarn-count')}}</span>
				</div>
			</div>
		</section>
		<transition name="slide-up" mode="out-in" appear>
			<section class="main">
				<form @submit.prvent="calc" ref="form">
					<div class="field">
						<div class="container">
							<div class="content">
								<div class="field-inner">
									<label for="sample-length">{{$t('sample-length-?')}}</label>
									<div class="element">
										<div class="flex">
											<input type="number" placeholder=" " min="0" step="any" id="sample-length" v-model="sampleLength">
										</div>
									</div>
									<label for="sample-weight">{{$t('sample-weight-?')}}</label>
									<div class="element">
										<div class="flex">
											<input type="number" placeholder=" " min="0" step="any" id="sample-weight" v-model="sampleWeight">
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</form>
				<hr>
				<div class="container">
					<div class="content">
						<!-- <span class="result">{{result | unit}} {{$t('yarn-count-unit')}}</span> -->
						<YarnCountTable :units.sync="units" :selected="$settings.data.defaultYarnCount"/>
					</div>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>
import YarnCountTable from '@/components/YarnCountTable.vue'

export default {
	data() {
		return {
			sampleLength: '',
			sampleWeight: '',
			result: '',
			units: [...this.$yarnCountUtils.units]
		};
	},
	components: {
		YarnCountTable
	},
	mounted() {
		this.convert();
	},
	watch: {
		sampleLength() {
			this.calc();
		},
		sampleWeight() {
			this.calc();
		}
	},
	methods: {
		calc() {
			if (!this.$refs.form.checkValidity()) {
				// Try focus on the error 
				this.$refs.form.reportValidity();
				return;
			}
			let sampleLength = this.$utils.sanitize(this.sampleLength);
			let sampleWeight = this.$utils.sanitize(this.sampleWeight);

			this.result = sampleLength / sampleWeight;
			this.result = this.$utils.sanitize(this.result);
			this.convert();
		},
		convert() {
			let self = this;
			this.units.forEach(function(unit, index) {
				unit.value = self.$yarnCountUtils.convert(self.result, 'nm', unit.code);
				self.$set(self.units, index, unit);
			});
		}
	}
}
</script>